enum StoreyType {
    All = 'ALL',
    Logement = 'LOG',
    Mixte = 'MIX',
}

export default StoreyType;